<section class="feature-wrapper">
  <p class="font-16 text-center text-white" translate>feature_title</p>
  <div class="feature py-3 bg-primary">
    <owl-carousel-o [options]="slideOption" dir="ltr" class="d-flex">
      <ng-template carouselSlide *ngFor="let item of items">
        <div class="imgHolder">
          <img [src]="item.img" alt="" />
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
</section>
